export const COMPANY = {
  name: "TaccTax Solution Pvt. Ltd.",
  short: "TaccTax",
  tagline: "Transforming complexity into clarity",
  phone: "+91 82401 81495",
  phoneHref: "tel:+918240181495",
  whatsapp: "https://wa.me/918240181495?text=Hi%20TaccTax%20—%20I'd%20like%20to%20discuss%20KPO%20support%20for%20our%20CPA%20firm.",
  email: "jainsaurabh077@gmail.com",
  founder: "CA Parth Chauhan",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Rate Sheet", href: "#rates" },
  { label: "Why Us", href: "#why" },
  { label: "Founder", href: "#founder" },
  { label: "Contact", href: "#contact" },
];

export const MARQUEE_ITEMS = [
  "US Bookkeeping",
  "Form 1040 — Individual",
  "Form 1065 — Partnership",
  "Form 1120 — C-Corp",
  "Form 1120-S — S-Corp",
  "Payroll Processing",
  "Sales & Use Tax",
  "Virtual CFO & MIS",
  "90+ US Clients",
  "12 US States Served",
];

export const CORE_SERVICES = [
  {
    id: "bookkeeping",
    title: "US Bookkeeping & Reconciliation",
    desc: "Monthly and periodic bookkeeping, bank & credit-card reconciliation, AP/AR management and clean, review-ready financials — on QuickBooks, Xero or your firm's preferred platform.",
    chips: ["QuickBooks", "Xero", "AP / AR", "Reconciliations"],
  },
  {
    id: "taxation",
    title: "US Taxation",
    desc: "Preparation of individual and business returns with full supporting workpapers — ready for your final review and e-filing.",
    chips: ["1040", "1065", "1120", "1120-S", "Workpapers included"],
  },
  {
    id: "payroll",
    title: "Payroll Processing",
    desc: "End-to-end payroll runs, compliance calculations and payroll tax filings for your clients' employees — federal and state.",
    chips: ["Payroll runs", "Tax filings", "Compliance calcs"],
  },
];

export const EXTENDED_SERVICES = [
  { title: "Financial Statement Preparation", desc: "Monthly, quarterly and year-end financials with schedules and workpapers." },
  { title: "Catch-Up & Clean-Up Bookkeeping", desc: "Reconstructing neglected books to a current, audit-ready position." },
  { title: "Sales & Use Tax Compliance", desc: "Multi-state calculation, return preparation and filing support." },
  { title: "1099 & W-2 Filing Support", desc: "Vendor tracking, form preparation and year-end information returns." },
  { title: "Foreign-Owned Entity Compliance", desc: "Form 5472 / 1120 reporting for US disregarded entities and foreign-owned structures." },
  { title: "Tax Planning & Advisory Support", desc: "Projection modelling, estimated-tax computations and year-end planning workpapers." },
  { title: "Audit & Review Support", desc: "Workpaper preparation, schedule build-out and documentation for assurance engagements." },
  { title: "Virtual CFO & MIS Reporting", desc: "Budgeting, cash-flow tracking, KPI dashboards and management reporting packs." },
];

export const RATES = [
  { service: "Bookkeeping", desc: "Ongoing monthly bookkeeping & reconciliation", rate: "$8 – $15 / hr" },
  { service: "Bookkeeping — Fixed", desc: "Small-business flat monthly package", rate: "$300 – $600 / mo" },
  { service: "Individual Tax (1040)", desc: "Simple to moderate complexity", rate: "$25 – $50 / return" },
  { service: "Individual Tax (1040) — Complex", desc: "Sch C/D/E, multi-state", rate: "$60 – $100 / return" },
  { service: "Business Tax", desc: "Forms 1065, 1120, 1120-S", rate: "$75 – $150 / return" },
  { service: "Payroll Processing", desc: "Per client base + per-employee add-on", rate: "$40 – $60 / mo + $2 – $5 / emp" },
  { service: "Sales & Use Tax", desc: "Per state return — preparation & filing", rate: "$25 – $50 / return" },
  { service: "Financial Statements", desc: "Compilation with schedules", rate: "$100 – $250 / set" },
  { service: "Clean-Up Bookkeeping", desc: "Backlog reconstruction, hourly", rate: "$10 – $18 / hr" },
  { service: "Virtual CFO / MIS", desc: "Monthly retainer, scope-based", rate: "$400 – $900 / mo" },
  { service: "Dedicated Resource", desc: "Full-time offshore staff, monthly", rate: "$1,200 – $2,000 / mo" },
];

export const WHY_US = [
  { title: "Proven Track Record", desc: "90+ US clients served across individual and business engagements — with the references to back it up." },
  { title: "Dedicated Oversight", desc: "Every deliverable is supervised by a Chartered Accountant before it reaches your review queue." },
  { title: "US-Focused Training", desc: "Team trained on US GAAP, IRS requirements and the software ecosystem your firm already runs on." },
  { title: "Flexible Engagement", desc: "Hourly, per-return, fixed monthly or a dedicated full-time resource — scale up for season, down after." },
  { title: "Confidentiality First", desc: "Strict confidentiality protocols with workflows aligned to IRS §7216 consent requirements for offshore preparation." },
];

export const STATES = [
  "California", "Texas", "New Jersey", "Illinois", "Pennsylvania", "North Carolina",
  "New York", "Florida", "Georgia", "Virginia", "Washington", "Arizona",
];

export const IMAGES = {
  team: "https://images.unsplash.com/photo-1556761175-b413da4baf72?crop=entropy&cs=srgb&fm=jpg&q=85",
  desk: "https://images.unsplash.com/photo-1707157284454-553ef0a4ed0d?crop=entropy&cs=srgb&fm=jpg&q=85",
  founder: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=85",
};
